<template>
    <div class="content">
        <div class="content-head">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="起止时间">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" style="width: 150px" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" style="width: 150px" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="审核状态">
                    <el-select v-model="params.auditstatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in optionsList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="订单号">
                    <el-input autocomplete="on" name="keyword"  v-model="params.keyword" placeholder="请输入订单号" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="申请单号">
                    <el-input autocomplete="on" name="erpcode"  v-model="params.erpcode" placeholder="请输入申请单号" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="退货单号">
                    <el-input autocomplete="on" name="RMASN"  v-model="params.rmasn" placeholder="请输入退货单号" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getOrdersDeliveryApplys(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-table">
            <div class="content-table-title">临时发货申请单列表</div>
            <el-table :data="tableList" ref="multipleTable" border style="width: 100%" :height="maxheight" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="Orders_SN" label="订单编号" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleViewsDetail(scope.row)">{{ scope.row.Orders_SN }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="Apply_SN" label="申请单号" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="Orders_Delivery_ERPSN" show-overflow-tooltip label="ERP发货审批单号" align="center"></el-table-column>
                <el-table-column prop="Apply_TotalPrice" show-overflow-tooltip label="申请总额" align="center" width="150">
                    <template slot-scope="scope">￥ {{ scope.row.Apply_TotalPrice.toFixed(2) }}</template>
                </el-table-column>
                <el-table-column prop="ApplyStatus" show-overflow-tooltip label="审核状态" align="center" width="150">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.ApplyStatus)">{{ scope.row.ApplyStatus }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" show-overflow-tooltip label="创建时间" width="200" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.createTime | formatDates }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleDetailsView(scope.row)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <TemporaryDeliveryDetails :dialogVisible="isDialogVisible" @refresh-parent="onRefresh" :id="Apply_ID" :orders="orders" @handleClose="handleClose" />
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import TemporaryDeliveryDetails from './components/TemporaryDeliveryDetails';
import { myMixin } from '@/utils/mixin.js';
import { formatDate } from '@/utils/utils.js';
import { cloneDeep } from 'lodash';
export default {
    name: 'temporaryDelivery',
    mixins: [myMixin],
    components: {
        Pagination,
        TemporaryDeliveryDetails
    },
    data() {
        return {
            Apply_ID: 0,
            orders: '',
            params: {
                date_start: '',
                date_end: '',
                auditstatus: 0,
                keyword: '',
                erpcode: '',
                rmasn: ''
            },
            loadingBtn: false,
            isDialogVisible: false,
            optionsList: [
                { value: 0, label: '全部单据' },
                { value: 1, label: '待送审' },
                { value: 2, label: '审核中' },
                { value: 3, label: '已审核' },
                { value: 4, label: '审核失败' },
                { value: -1, label: '送审失败' }
            ],
            tableList: []
        };
    },
    mounted() {
        this.getOrdersDeliveryApplys(true);
    },
    methods: {
        onRefresh() {
            this.params = {
                date_start: '',
                date_end: '',
                auditstatus: 0,
                keyword: '',
                erpcode: '',
                rmasn: ''
            };
            this.getOrdersDeliveryApplys(true);
        },
        //申请单管理列表
        getOrdersDeliveryApplys(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            let params = cloneDeep(this.params);
            this.$newsApi
                .getOrdersDeliveryApplys({ json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableList = res.data.data;
                        this.tableList.map((item) => {
                            item.createTime = item.Apply_Addtime;
                        });
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableList = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },

        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getOrdersDeliveryApplys();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getOrdersDeliveryApplys();
        },
        handleDetailsView(row) {
            console.log(row);
            this.Apply_ID = row.Apply_ID;
            this.orders = row.Orders_SN;
            this.isDialogVisible = true;
        },
        async handleViewsDetail(row) {
            
                this.$store.commit('SET_TAGTITLE', '订单详情');
                this.$router.push(`/orderManagement/orderDetails?id=${row.Apply_OrdersID}`);
                this.id = row.Orders_ID;

            
            return;

           
        },
        handleClose() {
            this.isDialogVisible = false;
        }
    }
};
</script>
<style scoped lang="scss">
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>